// Unreleased features stay in the codebase but are not exposed to trial users.
export const QUIZ_RELEASED = false;
export const AUTH_RELEASED = true;
export const CLOUD_ACCOUNT_RELEASED = false;
// CLA-136: school-calendar imports and their acceptance tests are temporarily paused.
export const CALENDAR_IMPORT_RELEASED = false;
export const DRIVE_SYNC_RELEASED = import.meta.env.VITE_DRIVE_SYNC_RELEASED === "true";
export const DRIVE_SYNC_INTERNAL = import.meta.env.VITE_DRIVE_SYNC_INTERNAL === "true";
// Private builds retain the invitation gate. Released builds use live Free Trial eligibility.
export const DRIVE_SYNC_INVITE = import.meta.env.VITE_DRIVE_SYNC_INVITE === "true";

export const DRIVE_SYNC_AVAILABLE = DRIVE_SYNC_RELEASED || DRIVE_SYNC_INVITE;
